import {Pipe, PipeTransform} from '@angular/core';
import {TemostaDataListValidationDto} from 'shared/dtos/temosta-data-list-validation-dto';
import {TesmostaDatalistValidatorValue} from 'shared/EnumsConstants/tesmosta-datalist-validator-value.enum';

@Pipe({
  name: 'cellStatusStyle',
  standalone: false
})
export class CellStatusStylePipe implements PipeTransform {
  transform(
    validator: TemostaDataListValidationDto[],
    auswertungAusgeschlossen: number
  ): unknown {
    if (
      auswertungAusgeschlossen ===
      TesmostaDatalistValidatorValue.AuswertungAusgeschlossen
    ) {
      return '';
    }

    let count = validator.filter(
      v => v && v.value === TesmostaDatalistValidatorValue.UngueltigerWert
    ).length;
    if (count > 0) {
      return 'cell-error';
    }

    count = validator.filter(
      v => v && v.value === TesmostaDatalistValidatorValue.AuffaelligerWert
    ).length;
    if (count > 0) {
      return 'cell-auffaellige';
    }
    return '';
  }
}
